<template>
  <kst-print-table :data="items">
    <b-table-column
      v-slot="{ column, row }"
      field="ItemID"
      :label="HppAdjItemCatalog.DispatchName.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="HppAdjItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty-print"
      field="Qty"
      :label="HppAdjItemCatalog.Qty.Label"
    >
      <kst-value multi-value :field="column.field" :data="row" :catalog="HppAdjItemCatalog">
        <kst-value multi-value field="PackagingName" :data="row" :catalog="HppAdjItemCatalog"/>
      </kst-value>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-hpptotal"
      field="HppTotal"
      :label="HppAdjItemCatalog.HppTotal.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="HppAdjItemCatalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import HppAdjItemCatalog from "../HppAdjItemCatalog.js";

export default {
  props: {
    data: Object,
    items: Array
  },
  data: () => ({
    HppAdjItemCatalog: HppAdjItemCatalog
  })
}
</script>